module.exports = __webpack_public_path__ + "img/img55.f951c69a.svg";